"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bus_rdf_parse_1 = require("@comunica/bus-rdf-parse");
const rdfa_streaming_parser_1 = require("rdfa-streaming-parser");
/**
 * A comunica XML RDFa RDF Parse Actor.
 */
class ActorRdfParseXmlRdfa extends bus_rdf_parse_1.ActorRdfParseFixedMediaTypes {
    constructor(args) {
        super(args);
    }
    async runHandle(action, mediaType, context) {
        const language = action.headers ? action.headers.get('content-language') : null;
        action.input.on('error', (e) => quads.emit('error', e));
        const quads = action.input.pipe(new rdfa_streaming_parser_1.RdfaParser({ baseIRI: action.baseIRI, profile: 'xml', language }));
        return { quads, triples: true };
    }
}
exports.ActorRdfParseXmlRdfa = ActorRdfParseXmlRdfa;
//# sourceMappingURL=ActorRdfParseXmlRdfa.js.map